!function (root, factory) {

	factory(root);
}(this, function (root) {

	function Overwatch() {

		this.extend = function (opts) {
			_.merge(this, opts);
		};
	};

	return root.overwatch = !(root.overwatch instanceof Overwatch) ? new Overwatch() : root.overwatch;
});

!function (root, factory) {

	factory(root, root.overwatch);
}(this, function (root, overwatch) {

	function Util() {

		var util = this;
		var document = root.document;
		var body = root.document.body;

		this.width = function () {
			return root.innerWidth || document.documentElement.clientWidth || body.clientWidth;
		};

		this.height = function () {
			return root.innerHeight || document.documentElement.clientHeight || body.clientHeight;
		};

		this.sizesArray = [
		// phones portrait
		{
			name: 'xs',
			min: 0,
			max: 400
		},
		// phones landscape
		{
			name: 'sm',
			min: 400,
			max: 768
		},
		// tablet portrait
		{
			name: 'md',
			min: 768,
			max: 992
		},
		// tablet landscape || small desktop
		{
			name: 'lg',
			min: 992,
			max: 1279
		},
		// large desktops
		{
			name: 'xl',
			min: 1280,
			max: 1600
		},
		// x-large desktops/ retina laptops
		{
			name: 'xxl',
			min: 1600,
			max: Infinity
		}];

		this.evaluateSize = function (sizeElement) {
			var width = util.width();
			return width >= sizeElement.min && width < sizeElement.max;
		};

		this.sizes = function () {
			return util.sizesArray.reduce(function (sizesObj, sizeElement) {
				sizesObj[sizeElement.name] = util.evaluateSize(sizeElement);

				return sizesObj;
			}, {});
		};

		this.mobile = function () {
			return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi/i.test(window.navigator.userAgent)
			);
		};

		this.touch = function () {
			return 'ontouchstart' in window || window.navigator.MaxTouchPoints > 0 || window.navigator.msMaxTouchPoints > 0;
		};

		this.vendor = function () {
			var vendor = null;
			var style = document.documentElement.style;
			_.each(['webkit', 'Moz', 'ms', 'O'], function (prefix, key) {
				if (style[prefix + 'Transform'] !== undefined) {
					vendor = prefix;
				}
			});
			return vendor;
		};

		this.size = function () {
			var size = null;
			_.each(util.sizes(), function (bool, key) {
				if (bool) size = key;
			});
			return size;
		};

		this.isSizeAtLeast = function (minBreakpoint) {
			var sizeElement = _.find(util.sizesArray, { name: minBreakpoint });

			return util.width() >= sizeElement.min;
		};

		this.ie = function () {
			var agent = root.navigator.userAgent;
			var ie_10down = /MSIE \d/.test(agent);
			var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.test(agent);
			return ie_10down || ie_11up;
		};

		this.browser = function () {

			var agent = root.navigator.userAgent;
			var vendor = root.navigator.vendor;

			var gecko = /gecko\/\d/i.test(agent);
			var chrome = /Chrome\//.test(agent);
			var safari = /Apple Computer/.test(vendor);
			var edge = /Edge/.test(agent);

			return {
				ie: util.ie(),
				gecko: gecko,
				chrome: chrome,
				safari: safari,
				edge: edge
			};
		};

		this.posX = function () {
			return root.pageXOffset || root.scrollX || body.scrollLeft || document.documentElement.scrollLeft;
		};

		this.posY = function () {
			return root.pageYOffset || root.scrollY || body.scrollTop || document.documentElement.scrollTop;
		};

		this.scroll = function () {
			return body.scrollHeight > body.clientHeight && body.style.position !== 'fixed';
		};

		this.vw = function (int) {
			return util.width() / 100 * int;
		};

		this.vh = function (int) {
			return util.height() / 100 * int;
		};
		this.addLoadEvent = function (callback) {
			var existingFn = window.onload;
			if (typeof window.onload !== "function") {
				window.onload = callback;
			} else {
				window.onload = function () {
					existingFn();
					callback();
				};
			}
		};
		/*
  ** func = a function passed in as an argument. The function to debounce.
  ** wait = millisecond value. Delay in collecting multiple calls. Default: 100.
  ** immediate = boolean. If set to true, the function will run immediately instead of waiting for the delay.
  */
		this.debounce = function (func, wait, immediate) {
			var timeout;
			return function () {
				var context = this,
				    args = arguments;
				var later = function () {
					timeout = null;
					if (!immediate) func.apply(context, args);
				};
				var callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (callNow) func.apply(context, args);
			};
		};

		this.clamp = function (num, min, max) {
			return num <= min ? min : num >= max ? max : num;
		};
	};

	overwatch.extend({ util: new Util() });
	overwatch.utils = overwatch.utils || overwatch.util;
});

!function (root, factory) {

	var localStorage;

	try {
		localStorage = root.localStorage;
	} catch (err) {
		//Catch error so it doesn't print error on user's client
		localStorage = null;
		console.log(err, 'localStorage unavaliable');
	}

	factory(root.overwatch, localStorage);
}(this, function (overwatch, localStorage) {

	function Storage() {

		var self = this;

		// check if localstorage is available
		this.available = function () {
			return localStorage ? true : false;
		};

		// serialize value and store by key
		this.set = function (key, value) {
			if (self.available()) {
				localStorage.setItem(key, JSON.stringify(value));
			} else {
				console.log('storage.set failed, localStorage unavaliable');
			}
		};

		// get value by key and deserialze
		this.get = function (key) {
			if (self.available()) {
				return JSON.parse(localStorage.getItem(key));
			} else {
				console.log('storage.get failed, localStorage unavaliable');
			}
		};

		// remove object from storage by key
		this.remove = function (key) {
			if (self.available()) {
				localStorage.removeItem(key);
			} else {
				console.log('storage.remove failed, localStorage unavaliable');
			}
		};

		// clear all data in storage
		this.clear = function () {
			if (self.available()) {
				localStorage.clear();
			} else {
				console.log('storage.clear failed, localStorage unavaliable');
			}
		};
	};

	overwatch.extend({ storage: new Storage() });

	return overwatch.storage;
});

!function (root, factory) {

	factory(root, root.overwatch);
}(this, function (root, overwatch) {

	function Blackout() {

		var blackout = this;
		var util = overwatch.util;

		var pos = 0;
		var isOpen = 0;
		var $root = $(root);
		var $body = $('body');
		var $elem = $('<div class="blackout" blackout />').appendTo($body);

		function setEvents() {
			$elem.on('click.blackout', function (event) {
				event.stopPropagation();
				blackout.hide();
			});
			// $root.on('resize.blackout', _.throttle(function(){
			//     if(util.width() <= 768){
			//         blackout.hide();
			//     }
			// }, 100));
			//$root.on('keyup.blackout', function(event){
			//    if(event.which === 27){
			//        blackout.hide();
			//    }
			//});
		};

		function show() {
			if (!isOpen) {
				isOpen = 1;
				$elem.trigger('show');
				$elem.toggleClass('open', true);
				setEvents();
				pos = $root.scrollTop();
				$body.css({ position: 'fixed', marginTop: -pos + 'px' });
			}
		};

		function hide() {
			if (isOpen) {
				isOpen = 0;
				$elem.trigger('hide');
				$elem.toggleClass('open', false);
				$body.css({ position: '', marginTop: '' });
				$root.scrollTop(pos);
				$elem.off('click.blackout');
				pos = 0;
				//$root.off('keyup.blackout');
				//$root.off('resize.blackout');
			}
		};

		this.show = show;

		this.hide = hide;

		this.open = show;

		this.close = hide;

		this.on = function () {
			$elem.on.apply($elem, arguments);
		};

		this.off = function () {
			$elem.off.apply($elem, arguments);
		};

		this.one = function () {
			$elem.one.apply($elem, arguments);
		};
	};

	overwatch.extend({ blackout: new Blackout() });

	return overwatch.blackout;
});

!function (root, factory) {

	factory(root, root.overwatch);
}(this, function (root, overwatch) {

	var blackout = overwatch.blackout;

	function Lightbox() {

		var lightbox = this;

		var time = 200;
		var isOpen = 0;
		var $root = $(root);
		var $body = $('body');
		var $elem = $('<div class="lightbox" lightbox="main"></div>').appendTo($body);
		var $container = $('<div class="lightbox-container"></div>').appendTo($elem);
		var $header = $('<div class="lightbox-header"></div>').appendTo($container);
		var $body = $('<div class="lightbox-body"></div>').appendTo($container);
		var $content = $('<div class="lightbox-content"></div>').appendTo($body);
		var $prev = $('<a href="#" class="lightbox-prev"></a>').appendTo($body);
		var $next = $('<a href="#" class="lightbox-next"></a>').appendTo($body);
		var $footer = $('<div class="lightbox-footer"></div>').appendTo($container);
		var $close = $('<div class="lightbox-close"></div>').appendTo($body);

		function setEvents() {

			$elem.on('click.lightbox', function lightboxClick(event) {
				if (event.target === $elem[0]) {
					lightbox.hide();
				}
				$elem.trigger('lightbox.background');
			});

			$close.one('click.lightbox', function closeButton(event) {
				event.stopPropagation();
				lightbox.hide();
				$elem.trigger('lightbox.x');
			});

			$root.on('keyup.lightbox', function keyPress(event) {

				var which = event.which;

				// if key matches prevent default
				if (/37|39|32|27/.test(which)) {
					event.preventDefault();
				}

				// esc key - close modal
				if (which == 27) {

					lightbox.hide();
					$elem.trigger('key.esc');

					// left arrow
				} else if (which == 37) {

					$elem.trigger('prev');

					// right arrow
				} else if (which == 39) {

					$elem.trigger('next');

					// space bar - if video exists pause or play
				} else if (which == 32) {

					$elem.trigger('pause');
				}
			});
		};

		function setOptionalClasses(opts) {
			if (opts.size === 'fluid') {
				$elem.toggleClass('fluid', true);
			} else {
				$elem.toggleClass('fluid', false);
			}

			if (opts.controls) {
				$body.toggleClass('m-controls', true);
			} else {
				$body.toggleClass('m-controls', false);
			}

			if (opts.loader) {
				$body.toggleClass('m-loader', true);
			} else {
				$body.toggleClass('m-loader', false);
			}

			if (opts.loader) {
				$body.toggleClass('m-loader', true);
			} else {
				$body.toggleClass('m-loader', false);
			}

			if (opts.media) {
				$container.toggleClass('m-media', true);
			} else {
				$container.toggleClass('m-media', false);
			}
		}

		function set(opts, callback) {
			var defaults = {
				size: "",
				controls: false,
				loader: true,
				media: true,
				body: null,
				header: null,
				footer: null
			};

			var opts = _.isPlainObject(opts) ? _.assign({}, defaults, opts) : defaults;
			var callback = _.isFunction(opts) ? opts : _.isFunction(callback) ? callback : _.noop;
			var $html = $(opts.content || null);

			setOptionalClasses(opts);

			if (opts.body) {
				var $bodyHtml;
				if (opts.media) {
					$bodyHtml = $(opts.body).addClass("lightbox-content m-media");
				} else {
					$bodyHtml = $('<div>', {
						"class": "lightbox-content",
						html: opts.body
					});
				}

				$content.remove();
				$content = $bodyHtml.appendTo($body);
			}

			if (opts.header) {
				$header.html(opts.header);
			}

			if (opts.footer) {
				$footer.html(opts.footer);
			}

			callback();
		};

		function show() {
			if (!isOpen) {
				isOpen = 1;
				blackout.show();
				setEvents();
				$elem.toggleClass('open', true);
				$elem.trigger('show');
			}
			set.apply(null, arguments);
		};

		function hide() {
			if (isOpen) {
				isOpen = 0;
				blackout.hide();
				$root.off('keyup.lightbox');
				$elem.toggleClass('open', false);
				$elem.trigger('hide');
				$container.off('click.lightbox');
			}
		};

		function empty() {
			$content.remove();
			$content = $('<div>');
			$header.empty();
			$footer.empty();
		};

		function init() {

			$prev.on('click.lightbox', function (event) {
				event.preventDefault();
				$elem.trigger('prev');
			});

			$next.on('click.lightbox', function (event) {
				event.preventDefault();
				$elem.trigger('next');
			});
		};

		this.set = set;

		this.show = show;

		this.hide = hide;

		this.open = show;

		this.close = hide;

		this.empty = empty;

		this.on = function () {
			$elem.on.apply($elem, arguments);
		};

		this.off = function () {
			$elem.off.apply($elem, arguments);
		};

		this.one = function () {
			$elem.one.apply($elem, arguments);
		};

		init();
	};

	overwatch.extend({ lightbox: new Lightbox() });

	return overwatch.lightbox;
});

!function (root, factory) {

	factory(root, root.overwatch);
}(this, function (root, overwatch) {

	var util = overwatch.util;
	var lightbox = overwatch.lightbox;

	// store api loaded state
	var uid = 0;
	var cache = {};
	var apiLoaded = 0;
	var apiLoading = 0;
	var apiError = 0;

	// buffer requests til api is loaded
	var apiBuffer = [];
	var errBuffer = [];

	// url strings
	var apiUrl = '//www.youtube.com/iframe_api/';
	var embedUrl = '//www.youtube.com/embed/';

	// default video player options
	var defaults = {
		id: null,
		states: {
			'-1': 'unstarted',
			'0': 'ended',
			'1': 'playing',
			'2': 'paused',
			'3': 'buffering',
			'5': 'video-cued'
		},
		params: {
			autoplay: 1,
			autohide: 1,
			controls: 1,
			modestbranding: 1,
			showinfo: 1,
			version: 3,
			enablejsapi: 1,
			wmode: 'transparent',
			rel: 0
		},
		build: {
			$play: true,
			$poster: true,
			$video: true
		},
		templates: {
			$play: function () {
				var video = this;
				var $elem = $('<div>', {
					addClass: 'play',
					on: {
						click: function () {
							if (video.loaded) {
								video.player.playVideo();
							} else {
								video.one('ready', function () {
									video.player.playVideo();
								});
							}
						}
					}
				});
				return $elem;
			},
			$poster: function () {
				return $('<div class="poster">');
			},
			$video: function () {
				var video = this;
				var $elem = $('<iframe>', {
					addClass: 'video',
					attr: {
						width: '100%',
						height: '100%',
						allowfullscreen: true,
						frameborder: 0,
						src: embedUrl + video.id + '?' + $.param(video.opts.params)
					}
				});
				return $elem;
			}
		}
	};

	function processApiBuffer() {
		for (var i = 0; i < apiBuffer.length; i++) {
			apiBuffer[i]();
		}
		apiBuffer = [];
	};

	function processErrBuffer() {
		for (var i = 0; i < errBuffer.length; i++) {
			errBuffer[i]();
		}
		errBuffer = [];
	};

	function loadIframeAPIScript() {

		if (!apiLoaded && !apiLoading && !apiError) {

			apiLoading = 1;

			var script = $('<script>', {
				attr: {
					async: true,
					src: apiUrl,
					type: 'text/javascript'
				}
			})[0];

			script.onerror = function () {
				apiLoaded = 0;
				apiError = 1;
				processErrBuffer();
			};

			// callback function when youtube api is ready
			window.onYouTubeIframeAPIReady = function () {

				apiLoaded = 1;
				apiLoading = 0;

				// process buffered requests
				processApiBuffer();
			};

			document.body.appendChild(script);
		}
	};

	/*
 * check if api is loaded, if not trigger load
 * store callbacks in buffer if not loaded
 */
	function loadIframeAPI(done, err) {

		var err = err || _.noop;
		var done = done || _.noop;

		// if api can't load run error
		if (apiError) {

			err();

			// if loaded run callback
		} else if (apiLoaded) {

			done();

			// if already loading push callback and error to buffers
		} else if (apiLoading) {

			apiBuffer.push(done);
			errBuffer.push(err);

			// if not loaded or loading trigger load
			// and push callback and error to buffers
		} else {

			apiBuffer.push(done);
			errBuffer.push(err);
			loadIframeAPIScript();
		}
	};

	// video object constructor
	function YoutubeVideo(opts, done) {

		var video = this;
		var done = done || _.noop;
		var opts = _.merge({}, defaults, opts);
		var vid = uid++;
		var elems = {};
		var $root = $(opts.elem);
		var state = null;

		function destroy() {
			$root.toggleClass(state, false);
			if (video.player.stopVideo) {
				video.player.stopVideo();
			}
			if (video.player.clearVideo) {
				video.player.clearVideo();
			}
			if (video.player.destroy) {
				video.player.destroy();
			}
			video.player = null;
			video.$root.empty();
			cache[vid] = null;
		};

		function init() {

			var browser = util.browser();

			$root.toggleClass('loading', true);
			$root.toggleClass('unstarted', true);
			$root.toggleClass('m-mobile', util.mobile());
			$root.toggleClass('m-touch', util.touch());
			$root.toggleClass('m-edge', browser.edge);
			$root.toggleClass('m-ie', browser.ie);
			$root.toggleClass('m-chrome', browser.chrome);
			$root.toggleClass('m-safari', browser.safari);
			$root.toggleClass('m-gecko', browser.gecko);

			_.each(opts.build, function (bool, name) {
				if (bool) {
					$root.append(elems[name] = opts.templates[name].call(video));
				}
			});

			loadIframeAPI(function () {

				video.player = new YT.Player(elems.$video[0], {

					events: {

						onReady: function (event) {
							video.loaded = 1;
							video.loading = 0;
							$root.toggleClass('loading', false);
							$root.trigger('ready');
							done(video);
						},

						onStateChange: function (event) {
							var newstate = opts.states[event.data];
							if (state) {
								$root.toggleClass(state, false);
							}
							$root.toggleClass(newstate, true);
							$root.trigger('stateChange', newstate);
							video.state = state = newstate;
						}
					}
				});
			});

			elems.$video.on('load', function () {
				$root.toggleClass('loading', false);
			});

			cache[vid] = video;
		};

		this.id = opts.id;
		this.loaded = 0;
		this.loading = 1;
		this.state = state;
		this.uid = vid;
		this.opts = opts;
		this.$root = $root;
		this.destroy = destroy;
		this.elems = elems;

		this.on = function () {
			$root.on.apply($root, arguments);
		};

		this.off = function () {
			$root.off.apply($root, arguments);
		};

		this.one = function () {
			$root.one.apply($root, arguments);
		};

		init();
	};

	function Video() {

		function create(opts, done) {
			return new YoutubeVideo(opts, done);
		};

		function destroy(video) {
			if (video.destroy) {
				return video.destroy();
			}
		};

		function createAll(done) {

			$('[video]').each(function () {

				create({
					elem: this,
					id: $(this).attr('video')
				}, done);
			});
		};

		function get(id) {
			return cache[id];
		};

		function set(opts) {
			return _.merge(defaults, opts);
		};

		function init() {};

		this.create = create;
		this.destroy = destroy;
		this.createAll = createAll;
		this.get = get;
		this.set = set;

		init();
	};

	loadIframeAPI();

	overwatch.extend({ video: new Video() });

	return overwatch.video;
});

/**
 * Hero Ability Showcase module
 */
!function (root, factory) {

	// amd
	if (typeof define === 'function' && define.amd) {
		define('overwatch-ability-showcase', ['overwatch', 'jQuery'], factory);

		// node
	} else if (typeof exports === 'object') {
		module.exports = factory(require('overwatch', 'jQuery'));

		// browser global
	} else {
		root.overwatch['AbilityShowcase'] = factory(root.overwatch, root.jQuery);
	}
}(this, function (overwatch, $) {

	// inner element selectors
	var SELECTOR_ABILITY_NAME = '.ability-name';
	var SELECTOR_ABILITY_BUTTON = '.ability-showcase-button';
	var SELECTOR_ABILITY_BUTTON_LIST = '.ability-button-list';
	var SELECTOR_PROGRESS_SVG = '.progress-svg';

	// classes to be toggled
	var CLASS_IS_PLAYING = 'is-active';

	/**
  * Ability Showcase
  * @Constructor
  * @param {string} showcase - Selector for this module's parent element
  */
	function AbilityShowcase(showcase) {
		var $showcase = $(showcase);

		// cache elements
		this.$videos = $showcase.find('video');
		this.videos = this.$videos.get();
		this.$abilityName = $showcase.find(SELECTOR_ABILITY_NAME);
		this.$abilityButtons = $showcase.find(SELECTOR_ABILITY_BUTTON);
		this.$abilityButtonsList = $showcase.find(SELECTOR_ABILITY_BUTTON_LIST);
		this.$currentProgressSvg = null;
		this.currentVideo = null;

		// grab metadata from ability buttons
		this.abilities = getAbilityData(this.$abilityButtons);

		this.length = this.videos.length;

		this.currentIndex = 0;
		this.nextIndex = null;
	}

	/**
  * Initializes this module for use.
  *
  * Adds video event handlers, button click event handlers, and plays the first video.
  */
	AbilityShowcase.prototype.init = function init() {
		var self = this;

		// register video event handlers
		self.$videos.on('ended', function loadNext() {
			// play queued up video if exists, otherwise play next video
			self.play(self.getNextIndex());
		});
		self.$videos.on('playing', function updateProgressBar() {
			// animate fill progress circle, completing the animation within the total duration of the video
			var videoDurationMs = self.currentVideo.duration * 1000;
			self.$currentProgressSvg.velocity({
				strokeDashoffset: [0, 314]
			}, videoDurationMs, 'linear');
		});

		// queue up (preload) next video on half way mark of current video
		self.$videos.on('timeupdate', function queueNext() {
			// only preload next video if it hasn't already been queued + preloaded
			if (self.nextIndex === null && self.length > 1) {
				var progress = getMediaProgressDec(this);
				if (progress > 0.5) {
					self.queue(self.getNextIndex());
				}
			}
		});

		// register ability button video play triggers
		self.$abilityButtonsList.on('click', 'li', function handleAbilityButtonClick() {
			var i = $(this).index();
			self.play(i);
		});

		// initialize first video
		self.load(self.currentIndex);
		self.play(self.currentIndex);
	};

	AbilityShowcase.prototype.getNextIndex = function getNextIndex() {
		return this.nextIndex !== null ? this.nextIndex : this.currentIndex + 1;
	};

	/**
  * Performs various DOM interactions to display a video's "play" state.
  *
  * @param {int} i - index of video to perform action upon
  */
	AbilityShowcase.prototype.displayPlay = function displayPlay(i) {
		i %= this.length;
		var ability = this.abilities[i];

		this.$abilityName.text(ability.name);
		this.$abilityButtons.eq(i).addClass(CLASS_IS_PLAYING);
		this.$videos.eq(i).addClass(CLASS_IS_PLAYING);

		// cache these elements that are repeatedly looked up
		this.currentVideo = this.videos[i];
		this.$currentProgressSvg = this.$abilityButtons.eq(i).find(SELECTOR_PROGRESS_SVG);
	};

	/**
  * Performs various DOM interactions to display a video's "stop" state.
  *
  * @param {int} i - index of video to perform action upon
  */
	AbilityShowcase.prototype.displayStop = function displayStop(i) {
		i %= this.length;
		this.$abilityButtons.eq(i).removeClass(CLASS_IS_PLAYING);
		this.$videos.eq(i).removeClass(CLASS_IS_PLAYING);

		// stop progress circle animation
		this.$abilityButtons.eq(i).find(SELECTOR_PROGRESS_SVG).velocity('stop').velocity({
			strokeDashoffset: 314 // default stroke dash offset
		}, 0);
	};

	/**
  * Plays a video by its index, updates the current video index, and presents
  * a "play" interface.
  *
  * If no index is provided, will play the current video.
  *
  * @param {int} [i=this.currentIndex] - index of video to perform action upon
  */
	AbilityShowcase.prototype.play = function play(i) {
		// stop whatever video may currently be playing
		this.stop(this.currentIndex);

		// play specified video, otherwise default to playing current video
		this.currentIndex = i === undefined ? this.currentIndex : i % this.length;

		// reset this video's progress before playing
		this.reset(this.currentIndex);

		this._play(this.currentIndex);

		// clear the next video queue
		this.nextIndex = null;
	};

	/**
  * Stops a video by its index and presents a "stop" interface.
  *
  * If no index is provided, will stop all videos.
  *
  * @param {int} [i] - index of video to perform action upon
  */
	AbilityShowcase.prototype.stop = function stop(i) {
		// no specific video to stop, so stop them all
		if (i === undefined) {
			this._stopAll();return;
		}

		i %= this.length;
		// TODO: ie11 breaks because of this? why?
		this.videos[i].pause();

		this.displayStop(i);
	};

	/**
  * Resets a video by its index to its start state. This does not pause the video.
  *
  * @param {int} i - index of video to perform action upon
  */
	AbilityShowcase.prototype.reset = function reset(i) {
		i %= this.length;
		// can only reset currenttime when video is ready (on certain browsers)
		// HAVE_ENOUGH_DATA - corresponds to 'canplay' media event
		if (this.videos[i].readyState === 4) {
			this.videos[i].currentTime = 0;
		}
	};

	/**
  * Queues a video by its index.
  *
  * If a video is already queued, this function does nothing.
  *
  * @param {int} i - index of video to perform action upon
  */
	AbilityShowcase.prototype.queue = function queue(i) {
		// another video already queued, exit
		if (this.nextIndex !== null) {
			return;
		}

		i %= this.length;
		this.nextIndex = i;

		// trigger preload
		this.load(i);
	};

	/**
  * Loads a video by its index.
  *
  * @param {int} i - index of video to perform action upon
  */
	AbilityShowcase.prototype.load = function load(i) {
		i %= this.length;
		this.videos[i].load();
	};

	/**
  * Plays a video by its index and presents a "play" interface.
  *
  * @param {int} i - index of video to perform action upon
  */
	AbilityShowcase.prototype._play = function _play(i) {
		i %= this.length;
		this.videos[i].play();

		this.displayPlay(i);
	};

	/**
  * Stops all videos, regardless of their play state.
  */
	AbilityShowcase.prototype._stopAll = function _stopAll() {
		for (var i = 0; i < this.length; i++) {
			this.stop(i);
		}
	};

	/**
  * Gets the progress of a media element.
  *
  * @param {HTMLMediaElement} media
  * @return {float} Decimal value (0.0 -> 1.0) representing media element progress
  */
	function getMediaProgressDec(media) {
		return media.currentTime / media.duration;
	}

	/**
  * Adapter function for retrieving ability data from ability buttons.
  *
  * @return {Array<Object>} Array of objects, each representing hero ability data.
  */
	function getAbilityData($abilityButtons) {
		return $.map($abilityButtons, function adaptAbilityData(button) {
			var $button = $(button);
			return {
				name: $button.data('ability-name')
			};
		});
	}

	overwatch.extend({ AbilityShowcase: AbilityShowcase });
	return AbilityShowcase;
});

!function (root, factory) {

	factory(root.overwatch);
}(this, function (overwatch) {

	function Animate() {

		function slideInLeft($elem, opts) {
			var opts = _.merge({ duration: 300, easing: 'easeOutCirc' }, opts);
			$elem.velocity({ translateX: ['+=100%', '-100%'], translateZ: 0 }, opts);
		};

		function slideOutLeft($elem, opts) {
			var opts = _.merge({ duration: 300, easing: 'easeOutCirc' }, opts);
			$elem.velocity({ translateX: ['-=100%', 0], translateZ: 0 }, opts);
		};

		this.slideInLeft = slideInLeft;
		this.slideOutLeft = slideOutLeft;
	};

	overwatch.extend({ animate: new Animate() });

	return overwatch.animate;
});

;(function (root) {
	var $ = root.$;
	$(".js-button-group").on("click", ".button", function (e) {
		$(this).siblings().removeClass("is-active");
		$(this).addClass("is-active");
	});
})(window);
!function (root, factory) {
	root.overwatch['CarouselSplit'] = factory(root.overwatch, root.jQuery);
}(this, function (overwatch, $) {

	var CLASS_NAMES = {
		CAROUSEL: 'CarouselSplit',
		CAROUSEL_SLANTED_MODIFIER: 'CarouselSplit--slanted',
		CAROUSEL_ITEM: 'CarouselSplit-item',
		ACTIVE_STATE: 'is-active',
		PREVIOUS_ACTIVE: 'was-active',
		PRE_ACTIVE_STATE: 'is-pre-active',
		ANIMATION_COMPLETE: 'is-animation-complete'
	};
	var SELECTORS = {
		CAROUSEL: '[data-js-carousel-split]',
		CAROUSEL_ITEM: '.CarouselSplit-item',
		CAROUSEL_ITEM_INACTIVE: '.CarouselSplit-item:not(.is-active)'
	};
	var DURATIONS = {
		FADE: 100,
		RESIZE: 350,
		DELAY: 0,
		HOVER_DELAY_FAST: 200,
		HOVER_DELAY_SLOW: 300
	};
	var SIZING = {
		ACTIVE_FLEX_GROW: 4,
		ACTIVE_FLEX_GROW_RATIO: 0.95
	};
	var defaultOptions = {
		beforeFadeOut: _.noop,
		beforeResize: _.noop,
		afterFadeIn: _.noop,
		afterResize: _.noop,
		fadeOut: fadeOut,
		fadeIn: fadeIn,
		shrink: shrink,
		grow: grow,
		delaySlow: false
	};

	// Should be called first
	var init = function init(options) {
		options = _.merge(defaultOptions, options);
		var $carousels = $(SELECTORS.CAROUSEL);
		var isTouchDevice = overwatch.util.touch();
		var selectEventName = isTouchDevice ? 'click' : 'mouseenter';
		$carousels.each(function (index, carousel) {
			var $carousel = $(carousel);
			var $carouselItems = $carousel.find(SELECTORS.CAROUSEL_ITEM);
			var selectSlideHandler = isTouchDevice ? createSelectHandler($carousel, $carouselItems, options) : createHoverIntentHandler($carousel, $carouselItems, options);
			$carousel.on(selectEventName, SELECTORS.CAROUSEL_ITEM_INACTIVE, // event delegation
			selectSlideHandler);
			// hover intent handler needs to be cleaned up when it's used
			if (!isTouchDevice) {
				$carousel.on('mouseleave', SELECTORS.CAROUSEL_ITEM_INACTIVE, // event delegation
				hoverIntentCleanupHandler);
			}
		});
	};

	/**
  * Element fadeOut animation
  *
  * @param {jQuery} $element - jQuery element to apply animation to
  * @return {Promise} Promise resolved when animation completes
  */
	function fadeOut($element) {
		return $.Velocity.animate($element, {
			'opacity': 0
		}, {
			duration: DURATIONS.FADE,
			delay: DURATIONS.DELAY
		});
	};

	/**
  * Element fadeIn animation
  *
  * @param {jQuery} $element - jQuery element to apply animation to
  * @return {Promise} Promise resolved when animation completes
  */
	function fadeIn($element) {
		return $.Velocity.animate($element, {
			'opacity': 1
		}, {
			duration: DURATIONS.FADE
		});
	};

	/**
  * Element shrink animation
  *
  * @param {jQuery} $element - jQuery element to apply animation to
  * @return {Promise} Promise resolved when animation completes
  */
	function shrink($element) {
		return $.Velocity.animate($element, {
			'flexGrow': 1
		}, {
			duration: DURATIONS.RESIZE,
			delay: 50,
			easing: 'easeInOutCubic'
		});
	};

	/**
  * Element grow animation
  *
  * @param {jQuery} $element - jQuery element to apply animation to
  * @return {Promise} Promise resolved when animation completes
  */
	function grow($element) {
		return $.Velocity.animate($element, {
			'flexGrow': 4
		}, {
			duration: DURATIONS.RESIZE,
			delay: 50,
			easing: 'easeInOutCubic'
		});
	};

	function animateSlideCollapse($slide, $nextActiveSlide, options) {
		options.beforeFadeOut($slide, $nextActiveSlide, DURATIONS);
		return options.fadeOut($slide.find('.CarouselSplit-transparentContent')).then(function () {
			options.beforeResize($slide, $nextActiveSlide, DURATIONS);
			options.shrink($slide);
		});
	}

	function animateSlideExpand($slide, $prevActiveSlide, options) {
		return options.grow($slide).then(function () {
			options.afterResize($prevActiveSlide, $slide, DURATIONS);
			return options.fadeIn($slide.find('.CarouselSplit-transparentContent'));
		}).then(function () {
			options.afterFadeIn($prevActiveSlide, $slide, DURATIONS);
		});
	}

	function createSelectHandler($carousel, $carouselItems, options) {
		return function (event) {
			var $currentlyActiveSlide = $carouselItems.filter('.' + CLASS_NAMES.ACTIVE_STATE);
			var $nextActiveSlide = $(this);
			// Clear out active state for all carousel items
			$carouselItems.removeClass(CLASS_NAMES.ACTIVE_STATE);
			$carouselItems.removeClass(CLASS_NAMES.ANIMATION_COMPLETE);
			// Add active state for only selected item
			$nextActiveSlide.removeClass(CLASS_NAMES.PRE_ACTIVE_STATE);
			$nextActiveSlide.addClass(CLASS_NAMES.ACTIVE_STATE);
			// Add previous active state for previous active item
			$currentlyActiveSlide.addClass(CLASS_NAMES.PREVIOUS_ACTIVE);
			return animateSlideCollapse($currentlyActiveSlide, $nextActiveSlide, options).then(function () {
				return animateSlideExpand($nextActiveSlide, $currentlyActiveSlide, options);
			}).then(function () {
				$currentlyActiveSlide.removeClass(CLASS_NAMES.PREVIOUS_ACTIVE);
				$nextActiveSlide.addClass(CLASS_NAMES.ANIMATION_COMPLETE);
			});
		};
	}

	/**
  * Creates a "hover intent" handler which toggles classes on an
  * element corresponding to the "intent" of the user interacting
  * with the element. States include:
  *
  * TODO: this could be its own declarative component
  *
  * - a pre-active class indicating ambiguity in whether a user is
  *   intending to interact
  * - an active class added when a user is clearly intending to
  *   interact
  */
	function createHoverIntentHandler($carousel, $carouselItems, options) {
		var selectHandler = createSelectHandler($carousel, $carouselItems, options);
		// initialize previous animation promise (none on initial page load)
		var prevPromise = Promise.resolve();
		return function () {
			var $nextActiveSlide = $(this);
			var animate = selectHandler.bind(this);
			$carouselItems.removeClass(CLASS_NAMES.PRE_ACTIVE_STATE);
			$nextActiveSlide.addClass(CLASS_NAMES.PRE_ACTIVE_STATE);
			var timeoutId = setTimeout(function () {
				// we want to queue up the next animation after the previous
				// animation, to make ensure that the different animations
				// aren't clobbering each other
				prevPromise = prevPromise.then(animate);
			}, options.delaySlow ? DURATIONS.HOVER_DELAY_SLOW : DURATIONS.HOVER_DELAY_FAST);
			// store timeout id on slide so it can be cancelled
			$nextActiveSlide.data('hover-intent-timeout-id', timeoutId);
		};
	}

	/**
  * Handler that cleans up state from "hover intent" handler.
  */
	function hoverIntentCleanupHandler(event) {
		var $exitedSlide = $(this);
		clearTimeout($exitedSlide.data('hover-intent-timeout-id'));
		$exitedSlide.removeClass(CLASS_NAMES.PRE_ACTIVE_STATE);
	}

	return {
		init: init
	};
});

!function (root, factory) {

	factory(root, root.jQuery, root.overwatch);
}(this, function (root, $, overwatch) {
	var carousel = {
		defaults: {
			numToShow: 1,
			numToSlide: 1,
			animationDuration: 500,
			autoScroll: false,
			timePerSlide: 5000,
			loop: true,
			pagination: true,
			slideWidth: 0,
			gutter: 12
		},
		item_width: 0,
		klass: "carousel",
		mask_klass: "carousel-mask",
		wrapper_klass: "carousel-wrapper",
		slide_klass: "carouse-slide",
		pagination_klass: "carousel-pagination",
		page_klass: "carousel-page",
		init: function (element, options) {
			this.options = _.merge({}, this.defaults, options);
			var options = this.options;
			this.element = element;
			this.setup();
			this.calculateDimensions();
			this.addElements();
			this.setupEvents();
			if (options.autoScroll) {
				this.startSliding();
			}
		},
		setup: function () {
			var options = this.options;
			this.element.addClass(this.klass);
			this.defineObjects();
			//this.determineStatus();
			if (options.pagination) {
				this.pagination = this.buildPagination();
			}
			if (options.slideWidth) {
				this.item_width = options.slideWidth;
			}
		},
		defineObjects: function () {
			var options = this.options;
			this.wrapper = this.element.children("ul").addClass(this.wrapper_klass);
			this.items = this.wrapper.children("li");
			this.pages = Math.ceil(this.items.length / options.numToSlide);
			this.mask = $("<div/>").addClass(this.mask_klass);
			this.duration = options.animationDuration;
		},
		buildPagination: function () {
			var options = this.options,
			    i = 1,
			    pageContainer = $("<ul/>").attr("class", this.pagination_klass),
			    html = "";
			while (i <= this.pages - (options.numToShow - options.numToSlide)) {
				html += '<li class="' + this.page_klass;
				if (i === 1) {
					html += ' is-active';
				}
				html += '" data-page="' + i + '"';
				html += ">&nbsp</li>";
				i++;
			}
			pageContainer.html(html);
			return pageContainer;
		},
		calculateDimensions: function () {
			var options = this.options,
			    self = this;

			this.items.addClass(self.slide_klass);

			if (options.numToShow === 1) {
				this.items.css("margin", 0);
			} else {
				this.items.css("margin", "0 " + options.gutter + "px");
			}
			if (this.item_width === 0) {
				this.item_width = this.items.first().outerWidth(true);
			}
			this.maxHeight = this.items.first().outerHeight(true);
			this.mask.css({
				width: this.item_width * options.numToShow,
				height: this.maxHeight
			});
			this.wrapper.css("width", this.item_width * this.items.length);
		},
		addElements: function () {
			var options = this.options;

			this.mask = this.wrapper.wrap(this.mask).parent();
			if (options.pagination) {
				this.element.append(this.pagination);
			}
		},
		setupEvents: function () {
			this.element.on("click", "." + this.page_klass, { self: this }, this.pageHandler);
		},
		pageHandler: function (event) {
			var self = event.data.self,
			    item = $(this),
			    options = self.options;

			event.preventDefault();
			self.gotoPage = item.data("page");
			self.slide();
		},
		slide: function (page, duration) {
			var self = this;

			this.stopSliding();

			if (page && typeof page === "number") {
				this.gotoPage = page;
			}
			if (typeof duration === "number") {
				this.duration = duration;
			}
			this.slideAmount = this.getSlideAmount();

			this.wrapper.velocity({
				left: this.slideAmount
			}, this.duration, function () {
				self.callback();
			});
		},
		callback: function () {
			var options = this.options;
			if (options.pagination) {
				var items = this.pagination.find("li");
				items.removeClass("is-active");
				var item = items.get(this.gotoPage - 1);
				$(item).addClass("is-active");
			}
			this.duration = options.animationDuration;
		},
		getSlideAmount: function () {
			var options = this.options;
			return -(this.item_width * options.numToSlide * (this.gotoPage - 1));
		},
		startSliding: function (time_to_show) {
			var self = this,
			    options = self.options;
			if (time_to_show && typeof time_to_show === "number") {
				options.timePerSlide = time_to_show;
			}
			this.interval = setInterval(function () {
				self.gotoPage++;
				self.slide();
			}, options.timePerSlide);
		},
		stopSliding: function () {
			clearInterval(this.interval);
		}
	};

	overwatch.extend({ carousel: carousel });
});
;(function () {
	$.fn.dropdown = function () {
		return this.each(function () {
			var dd,
			    span,
			    val,
			    $this,
			    klass,
			    select = this;
			$this = $(select);
			dd = $("<div />", {
				"class": "dropdown",
				style: "width:" + $this.outerWidth() + "px"
			});
			klass = $this.attr("class") ? $this.attr("class").replace("dropdown-select-element", "") : "";
			dd.addClass(klass);
			$this.removeClass(klass);
			dd = $this.wrap(dd).parent();
			val = $('option:selected', select).text();
			span = $("<span />", {
				"class": "dropdown-text",
				text: val
			}).prependTo(dd);
			$this.addClass("dropdown-select-element");
			$this.css('height', dd.outerHeight());
			$this.on("change", function () {
				val = $('option:selected', select).text();
				span.text(val);
			});
		});
	};
})(jQuery);

!function (root, factory) {
	root.overwatch['EventMapCarousel'] = factory(root.overwatch, root.jQuery);
}(this, function (overwatch, $) {

	var CLASS_NAMES = {
		CAROUSEL: 'EventMapCarousel',
		CAROUSEL_SLANTED_MODIFIER: 'EventMapCarousel--slanted',
		CAROUSEL_ITEM: 'EventMapCarousel-item',
		HIGHLIGHT_MODIFIER: 'EventMapCarousel-item--highlighted'
	};
	var SELECTORS = {
		CAROUSEL: '[data-js-carousel-split]',
		CAROUSEL_ITEM: '.EventMapCarousel-item'
	};

	// Should be called first
	function init() {
		var $carousels = $(SELECTORS.CAROUSEL);

		$carousels.each(function (index, carousel) {
			var $carousel = $(carousel);
			var $carouselItems = $carousel.find(SELECTORS.CAROUSEL_ITEM);
			$carousel.on('mouseenter click', SELECTORS.CAROUSEL_ITEM, // event delegation
			createSelectHandler($carousel, $carouselItems));
		});
	}

	function createSelectHandler($carousel, $carouselItems) {
		return function (event) {
			// Clear out highlighted class for all carousel items
			$carouselItems.removeClass(CLASS_NAMES.HIGHLIGHT_MODIFIER);
			// Add highlighted class for only selected item
			$(this).addClass(CLASS_NAMES.HIGHLIGHT_MODIFIER);
		};
	}

	return {
		init: init
	};
});

!function (root, factory) {

	factory(root, root.overwatch);
}(this, function (root, overwatch) {

	var util = overwatch.util;
	var lightbox = overwatch.lightbox;
	var video = overwatch.video;
	var messages = root.messages;

	var gallery_defaults = {
		elem: null
	};

	var media_defaults = {
		id: null,
		elem: null,
		data: {},
		gallery: null,
		index: null,
		result: null
	};

	//Used by Media to generate the html Header for the gallery
	function header(media) {
		if (media.gallery) {
			return [$('<h1>', {
				addClass: 'gallery-title',
				html: media.data.categoryName
			}), $('<p>', {
				addClass: 'gallery-index',
				html: media.index + 1 + ' / ' + media.gallery.length
			})];
		}
	};

	//Used by Media to generate the html Footer for the gallery
	function footer(media) {
		if (media.type == 'wallpaper') {

			return $('<div>', {
				addClass: 'gallery-sub-content row m-' + media.type,
				html: function () {
					var results = [];
					_.each(media.data.wallpaper, function (url, key) {
						results.push($('<a>', {
							addClass: 'column xs-6 md-4 lg-2 wallpaper-icon m-' + key.toLowerCase(),
							attr: {
								href: url,
								target: '_blank'
							},
							html: [$('<span>', { html: messages.wallpaper[key].title }), $('<span>', { html: messages.wallpaper[key].dimensions })]
						}));
					});
					return results;
				}()
			});
		} else {

			return $('<p>', {
				addClass: 'gallery-name',
				html: media.data.name
			});
		}
	};

	//Sets up click handlers on individual media elements to open the related Gallery.
	//Currently tightly coupled to the MediaGallery but also to the on-page implementation.
	function Media(opts) {

		var media = this;
		var opts = _.merge({}, media_defaults, opts);
		var item = opts.data;
		var type = item.type.toLowerCase();
		var $elem = $(opts.elem);
		var gallery = opts.gallery;

		function attach() {

			if (type == 'youtube') {

				var $video = $('<div video>');

				media.video = video.create({ elem: $video, id: item.youtubeId }, function (video) {
					video.player.playVideo();
				});

				lightbox.set({ body: $video, header: header(media), footer: footer(media), controls: media.gallery.length > 1 });
			} else if (type == 'video') {

				var $div = $('<div>', {
					addClass: 'gallery-item m-' + type + ' m-' + media.data.category
				});
				var $video = $('<video>', {
					attr: {
						autoplay: '',
						controls: ''
					}
				});
				$video.append($('<source>', {
					attr: {
						type: 'video/webm',
						src: item.videoWebm
					}
				}));
				$video.append($('<source>', {
					attr: {
						type: 'video/mp4',
						src: item.videoMp4
					}
				}));
				$div.append($video);

				lightbox.set({ body: $div, header: header(media), footer: footer(media), controls: media.gallery.length > 1 });
			} else if (type == 'pdf' || type == 'link') {

				var win = root.open(item.url, '_blank');

				if (win) {
					win.focus();
				}
			} else {
				var $div = $('<a>', {
					addClass: 'gallery-item m-' + type + ' m-' + media.data.category,
					attr: {
						href: item.url || item.wallpaper.urlStandard,
						target: '_blank'
					},
					css: {
						backgroundImage: 'url(' + (item.url || item.wallpaper.urlStandard) + ')'
					}
				});

				lightbox.set({ body: $div, header: header(media), footer: footer(media), controls: media.gallery.length > 1 });
			}
		};

		function detach() {

			if (media.data.type == 'youtube') {

				if (media.video) {
					media.video.destroy();
				}
				media.video = null;
			}

			lightbox.empty();
		};

		function init() {

			$elem.on('click', '[data-js=media-gallery-content]', function (event) {
				if (/youtube|pdf|link/.test(type) && (util.mobile() || util.touch())) {} else {
					event.preventDefault();
					$elem.trigger('open');
				}
			});
		};

		this.attach = attach;
		this.detach = detach;
		this.data = opts.data;
		this.index = opts.index;
		this.id = opts.id;
		this.gallery = opts.gallery;
		this.$elem = $elem;
		this.type = type;

		this.on = function () {
			$elem.on.apply($elem, arguments);
		};

		this.off = function () {
			$elem.off.apply($elem, arguments);
		};

		this.one = function () {
			$elem.one.apply($elem, arguments);
		};

		init();
	};

	//UI component
	function MediaGallery(opts) {

		var gallery = this;
		var cache = {};
		var results = [];
		var elems = {};
		var opts = _.merge({}, gallery_defaults, opts);
		var $elem = $(opts.elem);
		var active = null;
		var uid = 0;
		var isOpen = 0;

		function setEvents() {
			lightbox.on('prev', prev);
			lightbox.on('next', next);
			lightbox.on('pause', pause);
			lightbox.on('hide', close);
		};

		function add(media_opts) {
			var media;
			if (!cache[media_opts.id]) {
				_.merge(media_opts, {
					index: uid++,
					elem: media_opts.elem || elems[media_opts.id],
					gallery: gallery
				});
				media = cache[media_opts.id] = new Media(media_opts);
				if (media.type !== 'pdf') {
					media.result = results.push(media) - 1;
				}
				media.on('open', function (event) {
					open(media);
				});
				gallery.length++;
			}
		};

		function get(media) {
			return media instanceof Media ? media : cache[media] || results[media];
		};

		function to(media) {
			var media = get(media);
			if (active) {
				active.detach();
			}
			if (media) {
				active = media;
				active.attach();
			}
			$(document.body).trigger("ow.mediagallery.open", { id: media.id });
		};

		function open(media) {
			var media = get(media);
			to(media);
			if (media.type !== 'pdf' && media.type !== 'link') {
				if (!isOpen) {
					gallery.isOpen = isOpen = 1;
					setEvents();
					lightbox.open({ controls: results.length > 1 });
				}
			}
		};

		function close() {
			if (active) {
				active.detach();
			}
			if (isOpen) {
				gallery.isOpen = isOpen = 0;
				lightbox.off('prev', prev);
				lightbox.off('next', next);
				lightbox.off('pause', pause);
				lightbox.off('hide', close);
			}
			$(document.body).trigger("ow.mediagallery.close", { id: opts.id });
		};

		function prev() {
			var prev = active.result > 0 ? active.result - 1 : results.length - 1;
			to(results[prev]);
		};

		function next() {
			var next = active.result < results.length - 1 ? active.result + 1 : 0;
			to(results[next]);
		};

		function pause() {
			var player = active.video.player;
			if (player) {
				if (active.video.state === 'playing') {
					player.pauseVideo();
				} else {
					player.playVideo();
				}
			}
		};

		function init() {

			$elem.find('[data-media-id]').each(function () {
				var id = $(this).data('mediaId');
				elems[id] = this;
			});
		};

		this.add = add;
		this.prev = prev;
		this.next = next;
		this.pause = pause;
		this.close = close;
		this.open = open;
		this.to = to;
		this.get = get;
		this.length = 0;
		this.isOpen = 0;

		init();
	};

	//app logic for creating multiple MediaGalleries per media category
	function Gallery() {

		var uid = 0;
		var cache = {};

		function create(opts) {
			opts.uid = uid++;
			return cache[opts.id] = new MediaGallery(opts);
		};

		function get(id) {
			return cache[id];
		};

		function init() {
			$('[data-js-media-gallery]').each(function () {
				create({ elem: this, id: $(this).data('js-media-gallery') });
			});
		};

		this.create = create;
		this.get = get;

		init();
	};

	overwatch.extend({ Media: Media, gallery: new Gallery() });

	return overwatch.gallery;
});

!function (root, factory) {
	factory(root.overwatch);
}(this, function (root) {

	$.extend(jQuery.easing, {
		easeOutCirc: function (x, t, b, c, d) {
			return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
		}
	});

	function MenuScroll() {

		function init(options) {
			var timeToHideMs = options.timeToHideMs;
			var menu = options.menuSelector;

			// Hide bar after delay.
			setTimeout(function () {
				$(menu).addClass("is-menu-hidden");
			}, timeToHideMs);

			// Highlight first positioned menu option
			var sections = $("section");
			var firstSection = $(sections[0]).attr('id');
			$(menu + ' .' + firstSection).addClass("active");
			// Set up scrollspy and smooth scroll behavior.
			$(window).on('scroll', function () {
				requestAnimationFrame(function () {
					updateSideMenu(menu);
				});
			});
			$(window).on('touchmove', function () {
				requestAnimationFrame(function () {
					updateSideMenu(menu);
				});
			});
			$(menu + " li a").smoothScroll({ easing: "easeOutCirc", speed: 300, offset: -72, beforeScroll: function (e) {
					var scrollOffset = $(e.scrollTarget).data('scroll-offset');
					if (typeof scrollOffset !== 'undefined') {
						e.offset += parseInt(scrollOffset);
					}
				} });
		}

		function updateSideMenu(menu) {
			$(menu + " li").removeClass("active");

			var jWindow = $(window);
			var windowDimensions = {
				top: jWindow.scrollTop(),
				left: jWindow.scrollLeft(),
				right: jWindow.scrollLeft() + jWindow.width(),
				bottom: jWindow.scrollTop() + jWindow.height()
			};

			var sections = $("section");
			var lastFoundIndex = 0;
			for (var i = 0; i < sections.length; i++) {
				if (isSectionVisible(sections[i], windowDimensions)) {
					lastFoundIndex = i;
				}
			}
			$(menu + " ." + $(sections[lastFoundIndex]).attr("id")).addClass("active");
		}

		function isSectionVisible(section, wd) {
			var element = $(section);
			var elTop = element.offset().top;
			return wd.top + 73 >= elTop;
		}

		return {
			init: init
		};
	};

	return overwatch.extend({ menuScroll: new MenuScroll() });
});

/**
 * Progress module
 */
!function (root, factory) {

	// amd
	if (typeof define === 'function' && define.amd) {
		define('overwatch-progress', ['overwatch', 'jQuery'], factory);

		// node
	} else if (typeof exports === 'object') {
		module.exports = factory(require('overwatch', 'jQuery'));

		// browser global
	} else {
		root.overwatch['Progress'] = factory(root.overwatch, root.jQuery);
	}
}(this, function (overwatch, $) {

	$('.progress').each(function (i, progress) {
		var $progress = $(progress);
		var $glow = $progress.find('.glow');
		var percent = parseFloat($progress.data('overwatch-progress-percent'));
		var inversePercent = 1.0 - percent;
		var isAnimated = $progress.hasClass('m-animated');

		$glow.css('transform', 'scaleX(' + percent + ')');
		if (isAnimated) {
			$.Velocity.animate($progress.find('.cover'), {
				scaleX: inversePercent
			}, 2000).then(function activateGlow() {
				$glow.addClass('is-active');
			});
		} else {
			$progress.find('.cover').css('transform', 'scaleX(' + inversePercent + ')');
		}
	});

	$('.progress-2').each(function (i, progress) {
		var $progress = $(progress);
		var percent = parseFloat($progress.data('overwatch-progress-percent'));
		var percentCss = (1 - percent) * 100 + '%';
		var isAnimated = $progress.hasClass('m-animated');

		if (percentCss === '0%') {
			//jQuery/velocity does not like 0%
			percentCss = 0;
		}

		if (isAnimated) {
			$progress.find('.bar').velocity({
				right: percentCss
			}, {
				easing: 'ease',
				duration: 2000
			});
		} else {
			$progress.find('.bar').css('right', percentCss);
		}
	});
});

!function (root, factory) {

	factory(root, root.overwatch);
}(this, function (root, overwatch) {

	var util = overwatch.util;
	var lightbox = overwatch.lightbox;
	var storage = overwatch.storage;
	var datalayer = root.dataLayer;
	var location = root.location.search;

	var now = Math.floor(Date.now() / 1000);
	var cache = storage.get('promo') || {};

	var promo_defaults = {
		end: null,
		start: null,
		elem: null,
		id: null,
		count: 0
	};

	function save() {
		return storage.set('promo', cache);
	};

	function set(promo) {
		cache[promo.id] = promo;
		save();
	};

	function Promo(opts) {

		var promo = this;
		var opts = _.defaults(opts, promo_defaults);
		var $root = $(root);
		var isOpen = 0;

		function check() {
			return opts.start <= now && opts.end > now;
		};

		function setEvents() {

			$root.on('resize.promo', _.throttle(function () {
				if (util.width() < 768) {
					close();
				}
			}, 32));

			lightbox.one('lightbox.x.promo', function () {
				if (datalayer) {
					datalayer.push({ 'event': 'overlay-dismiss', 'analytics.eventPlacement': 'X' });
				}
			});
			lightbox.one('lightbox.background.promo', function () {
				if (datalayer) {
					datalayer.push({ 'event': 'overlay-dismiss', 'analytics.eventPlacement': 'Background' });
				}
			});
			lightbox.one('key.esc.promo', function () {
				if (datalayer) {
					datalayer.push({ 'event': 'overlay-dismiss', 'analytics.eventPlacement': 'Escape' });
				}
			});
			lightbox.one('hide.promo', function () {
				close();
			});
		};

		function removeEvents() {
			$root.off('resize.promo');
			lightbox.off('hide.promo');
			//lightbox.off('lightbox.x.promo lightbox.background.promo key.esc.promo');
		};

		function open() {
			if (!isOpen) {
				isOpen = 1;
				promo.count++;
				set(promo);
				setEvents();
				lightbox.open({ body: opts.elem });
			}
		};

		function close() {
			if (isOpen) {
				isOpen = 0;
				removeEvents();
				lightbox.close();
				lightbox.empty();
			}
		};

		function init() {
			set(promo);
		};

		this.start = opts.start;
		this.end = opts.end;
		this.elem = opts.elem;
		this.id = opts.id;
		this.open = open;
		this.close = close;
		this.check = check;
		this.count = opts.count;

		init();
	};

	function Promos() {

		var promos = {};

		function get(id) {
			return promos[id];
		};

		function create(opts) {

			var $elem = $(opts.elem);
			var id = opts.id || $elem.attr('promo');

			if (!promos[id]) {

				var promo = new Promo({
					elem: opts.elem,
					id: id,
					start: opts.start || $elem.attr('promo-start'),
					end: opts.end || $elem.attr('promo-end'),
					count: cache[id] ? cache[id].count : 0
				});

				promos[id] = promo;
			}
		};

		function init() {

			$('[promo]').each(function () {
				create({ elem: this });
			});

			if (!util.mobile() && util.width() > 768 && !/promo=false/.test(location)) {

				_.find(promos, function (o) {
					if (o.count < 1 && o.check() || window.location.hash.substr(1) === 'showpromo') {
						o.open();
						if (datalayer) {
							datalayer.push({ 'event': 'overlay.load' });
						}
						return true;
					}
				});
			}
		};

		this.get = get;
		this.create = create;

		init();
	};

	overwatch.extend({ promo: new Promos() });

	return overwatch.promo;
});

!function (root, factory) {

	factory(root, root.jQuery, root.overwatch);
}(this, function (root, $, overwatch) {

	var slideout = {
		cache: {},
		init: function () {
			var self = this;
			var slideoutContainers = $('[data-js="slideout-container"]');
			this.slideoutHandles = $('[data-js="slideout-handle"]');
			slideoutContainers.each(function () {
				var $this = $(this);
				self.cache[$this.data("slideoutId")] = {
					element: $this
				};
				//When this class is first added, don't use the transition so the container doesn't disappear over the course of the animation duration
				$this.addClass("Slideout-container Slideout-container--noTransition");
				$this.removeClass("Slideout-container--noTransition");
			});
			this.slideoutHandles.each(function () {
				var $this = $(this);
				var text = $this.text();
				var slideoutInstance = self.cache[$this.data("slideoutId")];
				slideoutInstance.openPrompt = text;
				slideoutInstance.closePrompt = $this.data("slideoutCloseText");
			});
			this.setupEventHandlers();
		},
		setupClickEventHandler: function () {
			var self = this;
			this.slideoutHandles.on("click", function (e) {
				e.preventDefault();
				var $this = $(this);
				var isOpen = $this.hasClass("is-active");
				var id = $this.data("slideoutId");
				var slideoutInstance = self.cache[$this.data("slideoutId")];
				$this.toggleClass("is-active");
				if (isOpen) {
					if (slideoutInstance.closePrompt) {
						$this.text(self.cache[id].openPrompt);
					}
					self.closeSlideout(id);
				} else {
					if (slideoutInstance.closePrompt) {
						$this.text(self.cache[id].closePrompt);
					}
					self.openSlideout(id);
				}
			});
		},
		setupResizeEventHandler: function () {
			var self = this;
			$(window).on("resize", overwatch.util.debounce(function () {
				for (key in self.cache) {
					if (self.cache[key].element.hasClass("is-open")) {
						self.updateSlideoutHeight(key);
					}
				}
			}));
		},
		setupEventHandlers: function () {
			this.setupClickEventHandler();
			this.setupResizeEventHandler();
		},
		openSlideout: function (id) {
			var slideoutHandler = $('[data-js="slideout-handle"][data-slideout-id="' + id + '"]');
			slideoutHandler.addClass("is-active");
			var slideoutContainer = this.cache[id].element;
			slideoutContainer.addClass("is-open");
			slideoutContainer.one("transitionend", function (event) {
				$(document.body).trigger("slideout:open", { event: event, id: id });
			});
			this.updateSlideoutHeight(id);
		},
		closeSlideout: function (id) {
			var slideoutHandler = $('[data-js="slideout-handle"][data-slideout-id="' + id + '"]');
			slideoutHandler.removeClass("is-active");
			var slideoutContainer = this.cache[id].element;
			slideoutContainer.removeClass("is-open");
			slideoutContainer.one("transitionend", function (event) {
				$(document.body).trigger("slideout:close", { event: event, id: id });
			});
			slideoutContainer.css("maxHeight", "");
		},
		updateSlideoutHeight: function (id) {
			var slideoutContainer = this.cache[id].element;
			var originalHeight = slideoutContainer.get(0).scrollHeight;
			slideoutContainer.css("maxHeight", originalHeight);
		}
	};

	overwatch.extend({ slideout: slideout });
});

/**
 * Spotlight component
 */
!function (root, factory) {

	factory(root.overwatch, root.jQuery);
}(this, function (overwatch, $) {

	var HEADER_HOOK = 'spotlight-header';
	var IMAGE_HOOK = 'spotlight-image';
	var CAPTION_HOOK = 'spotlight-caption';
	var HEADER_DATA = 'spotlightHeader';
	var IMAGE_DATA = 'spotlightImage';
	var CAPTION_DATA = 'spotlightCaption';
	var LIST_HOOK = 'spotlight-list';
	var ACTIVATOR_HOOK = 'spotlight-activator';
	var ACTIVE_CLASS = "is-active";
	var util = overwatch.util;
	var triggered = false;

	function Spotlight(spotlight, enableOnMobile) {
		var self = this;

		this.$spotlight = $(spotlight);
		this.id = this.$spotlight.data("id");
		this.$spotlightList = $("[data-js=" + LIST_HOOK + "][data-id=" + this.id + "]");
		this.$image = this.$spotlight.find('[data-js=' + IMAGE_HOOK + ']');
		this.$header = this.$spotlight.find('[data-js=' + HEADER_HOOK + ']');
		this.$caption = this.$spotlight.find('[data-js=' + CAPTION_HOOK + ']');
		this.$activators = this.$spotlightList.find("[data-js=" + ACTIVATOR_HOOK + "]");

		// warn about missing expected inner elements
		if (!this.id) {
			console.warn(this.$spotlight + " is missing an id. Please add the data-id attribute to the splotlight-list and spotlight");
		}
		if (this.$header.length === 0) {
			console.warn('Spotlight could not find a header element inside: ' + spotlight);
		}
		if (this.$image.length === 0) {
			console.warn('Spotlight could not find a holder element inside: ' + spotlight);
		}

		this.preselectSpotlight(this.$spotlightList);

		//Don't initialize for mobile;
		var isMobile = util.mobile() && util.touch();
		if (enableOnMobile || !isMobile) {
			this.setupEventHandlers();
		}
	}

	Spotlight.prototype.preloadSpotlightImages = function () {
		var i,
		    len,
		    $this_activator = null,
		    url,
		    $activators;
		$activators = this.$activators;
		for (i = 0, len = $activators.length; i < len; i++) {
			$this_activator = $activators.eq(i);
			url = $this_activator.data(IMAGE_HOOK);
			url = encodeURI(url);
			$('<img/>').attr('src', url).load(function success(event) {
				// prevent memory leaks
				$(this).remove();
			});
		}
	};

	Spotlight.prototype.preselectSpotlight = function ($spotlightList) {
		var active = $spotlightList.find("[data-js=" + ACTIVATOR_HOOK + "].is-active");
		this.loadData(active);
	};

	Spotlight.prototype.setupEventHandlers = function () {
		var self = this,
		    $element,
		    name,
		    url,
		    caption;
		this.$spotlightList.on('mouseenter.spotlight', "[data-js=" + ACTIVATOR_HOOK + "]", function (event) {
			$element = $(event.currentTarget);
			self.$activators.removeClass(ACTIVE_CLASS);
			$element.addClass(ACTIVE_CLASS);
			self.loadData($element);
			if (!triggered) {
				self.preloadSpotlightImages();
			}
			triggered = true;
		});
	};

	Spotlight.prototype.setHeader = function setHeader(text) {
		this.$header.text(text);
	};

	Spotlight.prototype.setCaption = function setCaption(text) {
		this.$caption.text(text);
	};

	/**
  * Performs an XHR to retrieve the specified image.
  * @param url [String] - image url
  * @param cb [Function] - callback on image load completion
  */
	Spotlight.prototype.loadData = function loadImage($element) {
		var self = this,
		    data,
		    name,
		    url,
		    caption;
		var data = $element.data();
		url = data[IMAGE_DATA];
		url = encodeURI(url);
		header = data[HEADER_DATA];
		caption = data[CAPTION_DATA];
		self._setImage(url);
		self.setHeader(header);
		self.setCaption(caption);
	};

	/**
  * Performs DOM manipulation necessary to update spotlight image.
  * @param url [String] - image url
  */
	Spotlight.prototype._setImage = function setImage(url, cb) {
		this.$image.css('background-image', 'url(' + encodeURI(url) + ')');
		if (typeof cb === "function") {
			cb();
		}
	};

	Spotlight.prototype._startTransition = function startTransition(cb) {
		this.$spotlight.velocity('stop').velocity({
			opacity: 0
		}, {
			duration: 100,
			easing: 'easeOutQuad',
			complete: function () {
				if (typeof cb === "function") {
					cb();
				}
			}
		});
	};

	Spotlight.prototype._endTransition = function endTransition(cb) {
		this.$spotlight.velocity({
			opacity: [1, 0]
		}, {
			duration: 100,
			easing: 'easeOutQuad',
			complete: function () {
				if (typeof cb === "function") {
					cb();
				}
			}
		});
	};

	overwatch.extend({ Spotlight: Spotlight });

	return Spotlight;
});

!function (root, factory) {

	factory(root.overwatch);
}(this, function (overwatch) {

	// tag elements/ modules
	function Tag(attr, items, opts) {

		var tag = this;

		// hash table for elements by
		// normalized attribute value
		var cache = {};

		// hash table for callbacks
		var cbmap = {};

		// local storage helper
		var storage = overwatch.storage;

		// default rule to parse
		// for triggering callbacks
		function defaultRule() {
			return this.exec < 1 ? true : false;
		};

		// helper to normalize key names
		function toCamelCase(string) {
			return string.replace(/-([a-z])/g, function (g) {
				return g[1].toUpperCase();
			});
		};

		// helper to normalize attribute selector
		function fromCamelCase(string) {
			return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
		};

		// return local storage key string
		function storageKey() {
			return ['tags', toCamelCase(attr)].join('.');
		};

		// transform tag item to be ready
		// for serialization to localstorage
		function storageItem(item) {
			return {
				created: item.created,
				exec: item.exec
			};
		}

		// create a cache item from a node
		// and previously stored object
		function cacheItem(node, prev) {
			return {
				$elem: $(node),
				created: prev && prev.created || new Date().getTime(),
				exec: prev && prev.exec || 0
			};
		};

		// return the stored data for this selector
		function getStorage() {
			return storage.get(storageKey()) || {};
		};

		// set the stored data for this selector
		function setStorage() {
			var obj = getStorage();
			var keys = Object.keys(cache);
			for (var i = 0; i < keys.length; i++) {
				var item = cache[keys[i]];
				obj[keys[i]] = storageItem(item);
			}
			storage.set(storageKey(), obj);
		};

		// parse an item rule
		// should always return boolean
		function parseRule(item) {
			var rule = item.rule || defaultRule;
			return rule.call(item);
		};

		// trigger an item's callback by name
		// executes based on parsed rule boolean
		function trigger(name) {
			var name = toCamelCase(name);
			var item = cache[name];
			var callback = cbmap[name];
			if (parseRule(item)) {
				callback.call(item, item.$elem, item.exec, item.created);
				item.exec++;
				setStorage();
			}
		};

		// build cached storage
		function buildCache(attr) {
			var elems = document.querySelectorAll('[' + fromCamelCase(attr) + ']');
			var store = getStorage();
			for (var i = 0; i < elems.length; i++) {
				var node = elems[i];
				var id = node.getAttribute(fromCamelCase(attr));
				var prev = store[toCamelCase(id)];
				cache[toCamelCase(id)] = cacheItem(node, prev);
			}
		};

		// add a cached item by name and config
		function addItem(name, config) {
			var name = toCamelCase(name);
			var item = cache[name];
			if (item && config.rule) {
				item.rule = config.rule;
			}
			if (item && config.callback) {
				cbmap[name] = config.callback;
				item.trigger = function () {
					trigger(name);
				};
				item.trigger();
			}
		};

		// add group of items by object key/value map
		function addItems(items) {
			var keys = Object.keys(items);
			for (var i = 0; i < keys.length; i++) {
				addItem(keys[i], items[keys[i]]);
			}
		};

		// sets the default rule for callbacks
		function setDefaultRule(rule) {
			if (rule instanceof Function) {
				defaultRule = rule;
			}
		};

		// initialize and build
		function init() {

			// clear storage if set
			if (opts && opts.clearStorage) {
				storage.remove(storageKey());
			}

			// set default rule if set
			if (opts && opts.defaultRule) {
				setDefaultRule(opts.defaultRule);
			}

			// build cache hash table
			buildCache(attr);

			// add callbacks/ rules
			addItems(items);

			// set namespace
			overwatch.tags ? null : overwatch.tags = {};

			// add to namespace cache
			overwatch.tags[toCamelCase(attr)] = tag;

			// expose api functions
			tag.cache = cache;
			tag.add = addItems;
			tag.trigger = trigger;
			tag.setDefaultRule = setDefaultRule;

			// save state to local storage
			setStorage();
		};

		init();
	};

	overwatch.extend({ Tag: Tag });

	return overwatch.Tag;
});

!function (root, factory) {

	factory(root, root.overwatch);
}(this, function (root, overwatch) {

	/**
  * Takes the card and arrow DOM object and calculates the left offset
  * for the arrow.
  *
  * We get the position relative to the container of the card and add it
  * to half of the width of the card minus half of the width of the arrow
  * to center the arrow.
  *
  * @param {Object} card
  * @param {Object} arrow
  */
	var getTooltipLeftOffsetCentered = function (card, arrow, tooltipOffset) {
		return card.offsetLeft + card.offsetWidth / 2 - arrow.offsetWidth / 2 - tooltipOffset;
	};
	var utils = overwatch.utils;
	var $window = $(window);

	var tooltip = {
		init: function () {
			this.generateTooltip();
			this.setupEvents();
		},
		generateTooltip: function () {
			this.tooltip = $('<div id="tooltip" class="Tooltip"><div class="Tooltip-arrow"></div><div class="Tooltip-body"></div></div>');
			this.tooltip.appendTo($(document.body));
			this.tooltipText = this.tooltip.find(".Tooltip-body");
			this.tooltipArrow = this.tooltip.find(".Tooltip-arrow");
		},
		setupEvents: function () {
			var self = this;
			$('[data-tooltip]').on('click', function (e) {
				var $this = $(this);
				self.activeHandle = $this;
				var tip = $("#" + $this.data('tooltip')).html();
				self.populateTooltip(tip);
				self.tooltip.show();
				self.positionTooltip();
			});
			$(document.body).on("click", function (event) {
				if ($(event.target).closest('[data-tooltip]').length === 0) {
					self.tooltip.hide();
				}
			});
			$window.resize(_.debounce(function () {
				self.positionTooltip();
			}, 500));
		},
		getHandleInfo: function () {
			var offset = this.activeHandle.offset();
			return {
				left: offset.left,
				top: offset.top,
				width: this.activeHandle.outerWidth(),
				height: this.activeHandle.outerHeight()
			};
		},
		getTooltipSize: function () {
			return {
				width: this.tooltip.outerWidth(),
				height: this.tooltip.outerHeight() + this.tooltipArrow.outerHeight() / 2
			};
		},
		getLeftPosition: function (handleInfo, tooltipSize) {
			var maxWidth = $(document.body).outerWidth() - tooltipSize.width;
			var minWidth = 0;
			//find the center point of the handle by adding its left offet and half its width.
			//subtract half the width of the tooltip and using this left value should align both the handle and the tips centers.
			var desiredLeftPosition = handleInfo.left + handleInfo.width / 2 - tooltipSize.width / 2;
			var clampedLeftPosition = utils.clamp(desiredLeftPosition, minWidth, maxWidth);
			this.tooltipOffset = desiredLeftPosition - clampedLeftPosition;
			return clampedLeftPosition;
		},
		getTopPosition: function (handleInfo, tooltipSize) {
			//TODO: Get this working properly so the tooltip appears above or below the handle dynamically.
			var screenYHalfwayPoint = $window.scrollTop() + $window.height() / 2;
			var handleElementYHalfwayPoint = handleInfo.top + handleInfo.height / 2;
			var topPlacement = handleElementYHalfwayPoint > screenYHalfwayPoint;
			var tooltipTopPosition = topPlacement ? handleInfo.top - tooltipSize.height : handleInfo.top + handleInfo.height;
			return tooltipTopPosition;
		},
		positionTooltip: function () {
			this.tooltip.css({ left: 0, top: 0 });
			var handleInfo = this.getHandleInfo();
			var tooltipSize = this.getTooltipSize();
			this.tooltip.css({
				left: this.getLeftPosition(handleInfo, tooltipSize),
				top: handleInfo.top - tooltipSize.height
			});
			this.positionTooltipArrow();
		},
		positionTooltipArrow: function () {
			var arrowLeftValue = this.tooltipOffset === 0 ? "50%" : "calc(50% + " + this.tooltipOffset + "px)";
			this.tooltipArrow.css({
				left: arrowLeftValue
			});
		},
		populateTooltip: function (html) {
			this.tooltipText.html(html);
		}
	};

	overwatch.extend({ tooltip: tooltip });

	return overwatch.tooltip;
});

!function (root, factory) {

	factory(root, root.overwatch);
}(this, function (root, overwatch) {

	function Waypoint() {};

	overwatch.extend({ waypoint: new Waypoint() });

	return overwatch.waypoint;
});

/*
* hero-selector.js
* extends overwatch module with hero-selector
*/
(function (root, factory) {

	// amd
	if (typeof define === 'function' && define.amd) {
		define('overwatch-hero-selector', ['overwatch', 'shuffle'], factory);

		// node
	} else if (typeof exports === 'object') {
		module.exports = factory(require('overwatch', 'shuffle'));

		// browser global
	} else {
		root.overwatch['HeroSelector'] = factory(root.overwatch, root.jQuery, root.shuffle);
	}
})(this, function (overwatch, $, shuffle) {

	// Allows "Filtering" of heroes
	function HeroSelector() {
		this.init = function init(options) {
			var self = this;
			self.$grid = options.$container;
			var $sizer = options.$sizer;
			self.$navigationLinks = options.$navigationLinks;
			self.itemSelector = options.itemSelector;

			//Init shuffle
			self.$grid.shuffle({
				itemSelector: self.itemSelector,
				speed: 200,
				easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'
			});

			// This gets the largest order the the group, used to "push" filtered results to the 
			// top, but also keep the other items ordered properly.	
			self.largestOrder = function () {
				var largest = 0;
				$.each($(self.itemSelector), function (key, value) {
					if (largest < $(value).data('order')) {
						largest = $(value).data('order');
					}
				});
				return largest;
			}();

			self.$navigationLinks.on('click', function () {
				var filterKey = $(this).data('filter-key');
				self.filter(filterKey);
			});
		};
	};

	HeroSelector.prototype.filter = function filter(filterKey) {
		var self = this;
		window.location.hash = filterKey.toLowerCase();

		self.$navigationLinks.parent().removeClass('active');
		$('[data-filter-key="' + filterKey + '"]', self.$navigationLinks.parent()).parent().addClass('active');

		if (filterKey === 'all') {
			$(self.itemSelector).children().removeClass('m-subdued m-selected');
			var opts = {};
		} else {
			var opts = {
				reverse: true,
				//Function to sort by
				by: function ($el) {
					var $elChild = $($el.children()[0]);
					$elChild.removeClass('m-subdued m-selected');

					if ($el.data('groups')[0] === filterKey) {
						$elChild.addClass('m-selected');
						// Subtract the largest order fron the order that is in the filter to
						// "push" those items to the top (make all of them rank "higher" than the others, but keep their order)
						return self.largestOrder - $el.data('order');
					}
					$elChild.addClass('m-subdued');
					// If it's not in the selected group, just keep the existing order, but opposite because the filter order is reverse.
					return ~$el.data('order');
				}
			};
		}

		this.$grid.shuffle('sort', opts);
	};

	// create heroSelector
	var heroSelector = new HeroSelector();

	// return heroSelector
	return heroSelector;
});